import { Names, Values } from '@mode-switch/model';
export var QueryResult;
(function (QueryResult) {
    let Type;
    (function (Type) {
        Type["URL"] = "URL";
        Type["Inline"] = "INLINE";
    })(Type = QueryResult.Type || (QueryResult.Type = {}));
    let Format;
    (function (Format) {
        Format["CSV"] = "CSV";
        Format["JSON"] = "JSON";
    })(Format = QueryResult.Format || (QueryResult.Format = {}));
    let Column;
    (function (Column) {
        function make(name, alias, source, type, role) {
            return { name, alias, source, type, role };
        }
        Column.make = make;
        function get(result, alias) {
            for (const column of result.columns) {
                if (column.alias === alias) {
                    return column;
                }
            }
            return null;
        }
        Column.get = get;
        function value(result, item, name) {
            switch (name) {
                case Names.Name: {
                    const alias = item[Names.Name];
                    const column = Column.get(result, alias);
                    return column ? column.name : null;
                }
                case Values.Name: {
                    const alias = item[Names.Name];
                    const column = Column.get(result, alias);
                    return column ? item[column.alias] : null;
                }
                default:
                    return item[name];
            }
        }
        Column.value = value;
    })(Column = QueryResult.Column || (QueryResult.Column = {}));
    let Inline;
    (function (Inline) {
        function make(format, query, items) {
            const { id, name } = query;
            const add = (fields, field) => {
                const { alias, formula } = field;
                return [
                    ...fields,
                    Column.make(field.name, alias, formula.source, formula.type, field.formula.role),
                ];
            };
            let columns = new Array();
            switch (query.type) {
                case "TABLE": {
                    for (const column of query.fields || []) {
                        columns = add(columns, column);
                    }
                    for (const alias of query.aliases || []) {
                        let column;
                        for (const field of query.fields || []) {
                            if (field.alias === alias.source) {
                                column = field;
                            }
                        }
                        if (column) {
                            add(columns, column);
                        }
                    }
                    break;
                }
                case "PIVOT": {
                    const queryColumns = [
                        ...(query.column || []),
                        ...(query.x || []),
                        ...(query.row || []),
                        ...(query.y || []),
                        ...(query.marks || []),
                        ...(query.values || []),
                    ];
                    for (const column of queryColumns) {
                        columns = add(columns, column);
                    }
                    for (const alias of query.aliases || []) {
                        let column;
                        for (const field of queryColumns) {
                            if (field.alias === alias.source) {
                                column = field;
                            }
                        }
                        if (column) {
                            add(columns, column);
                        }
                    }
                    break;
                }
            }
            return { id, name, items, format, columns, type: "INLINE" };
        }
        Inline.make = make;
        function expand(result, query) {
            const items = [];
            const { format } = result;
            if (query.aliases === undefined || query.aliases.length === 0) {
                return result;
            }
            for (const datum of result.items) {
                const item = { ...datum };
                for (const alias of query.aliases) {
                    item[alias.name] = item[alias.source];
                }
                items.push(item);
            }
            return make(format, query, items);
        }
        Inline.expand = expand;
    })(Inline = QueryResult.Inline || (QueryResult.Inline = {}));
    let URL;
    (function (URL) {
        function make(id, url, columns, format, name) {
            return { id, url, format, columns, name: name || id, type: "URL" };
        }
        URL.make = make;
    })(URL = QueryResult.URL || (QueryResult.URL = {}));
})(QueryResult || (QueryResult = {}));
